import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant';
//
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat); //

//
export const selection = data => {
  const {
    pageIndex,
    pageSize,
    ...filters
  } = data;
  return axios.post(Urls.selectUrl, {
    page: pageIndex,
    page_size: pageSize,
    filters,
    orders: {
      created_at: {
        desc: true,
        enable: true
      }
    }
  });
};
export const useSelect = ({
  params,
  config
}) => {
  return useQuery({
    queryKey: [ListQueryKey, params],
    queryFn: () => selection(params),
    ...config
  });
};